<template>
  <form-capsule :formTitle="$t('businessDocuments.business_doc_negotiation')">
    <template slot="formcontent">
      {{ document.id }}
    </template>
    <template slot="footerbuttons">
    </template>
  </form-capsule>
</template>
<script>
import formCapsule from '@/components/common/formCapsule.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
// import {errorMessageAlert} from '@/helpers/alert'

/** @author TLV 13/11/2020
* @brief Component for negotiating Business Documents
*/
export default {
  name: 'NegotiateDocumentForm',
  components: {
    'form-capsule': formCapsule,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-accordion': FormAccordion
  },
  data () {
    return {
      document: {}
    }
  },
  created () {
    this.document = this.$engine.services.businessDocuments.currentDocument
  }
}
</script>



// WEBPACK FOOTER //
// BusinessDocumentNegotiation.vue?1df6b376